import { prettyPrintObjectToString } from "@/common/application/prettyPrintObjectToString";

export const generateErrorMailtoLink = (error: unknown) => {
    const message = prettyPrintObjectToString(error);
    const stack =
        (error instanceof Error ? error.stack : undefined) ?? "No error stack.";

    const currentUrl = window.location.href;

    const body = `Hey Wezoo Team,
                    
I ran into an issue while using your website. I was on

${encodeURIComponent(currentUrl)}

and encountered the following error:

${message}

${stack}

Please help me resolve this issue. Thanks!`.replaceAll("\n", "%0D%0A");
    return `mailto:tech@wezoo.com?subject=I encountered an error on Wezoo&body=${body}`;
};
